import { Button } from '@kizen/kds/Button';
import { Spacer } from '@kizen/kds/Spacer';
import { useTranslation } from 'react-i18next';
import { AbsoluteLoader } from './styles';
import { useSetupAssistant } from '@kizenapps/engine/react';
import { isActionMenuFieldKey } from '@kizenapps/engine/util';

type InlineSaveProps = {
  disabled: boolean;
  onClick: (result: Record<string, any>) => Promise<unknown>;
};

export const InlineSave = ({ disabled, onClick }: InlineSaveProps) => {
  const { t } = useTranslation();

  const {
    inferencePending,
    state,
    expressionsIdle,
    validateForm,
    initialExpressionsPending,
    waitingExpressionCount,
  } = useSetupAssistant();

  const showBlockingLoader =
    inferencePending || !expressionsIdle || initialExpressionsPending;

  const showExpressionLoader = waitingExpressionCount > 0;

  return (
    <>
      <Spacer size={20} />
      <div className="flex">
        <div className="ml-auto">
          <Button
            disabled={disabled}
            onClick={async () => {
              const { isValid, includedKeys } = await validateForm();

              if (isValid) {
                const result: Record<string, any> = {};

                includedKeys.forEach((key: string) => {
                  result[key] = state[key];
                });

                // Synthetic per-(action, object) menu booleans aren't part of
                // the engine's flattened-fields - we allow them here
                Object.keys(state).forEach((key) => {
                  if (isActionMenuFieldKey(key)) {
                    result[key] = state[key];
                  }
                });

                onClick(result);
              }
            }}
          >
            {t('Save')}
          </Button>
        </div>
      </div>
      {showBlockingLoader ? (
        <div className="absolute left-0 right-0 top-0 bottom-0">
          <AbsoluteLoader loading />
        </div>
      ) : null}
      {showExpressionLoader && !showBlockingLoader ? (
        <div className="absolute left-0 right-0 top-0 bottom-0">
          <AbsoluteLoader loading transparent />
        </div>
      ) : null}
    </>
  );
};
